import { getRandomUUID } from '@app/utils'

import type { DropdownMenuItem } from '@app/types/dropdown'

export const INITIAL_CHECKBOX: DropdownMenuItem = {
  id: getRandomUUID(),
  value: 'all',
  label: 'Все'
} as const
